import { confirmAction } from "@/lib/dialogs";

/** Logging out by hand asks first. (A session that expires still signs out without asking: that path does not come through here.) */
export async function confirmLogout(logout) {
  const ok = await confirmAction({ title: "Are you sure you want to logout?", description: "You will need to sign in again to continue.",
    confirmLabel: "Confirm", cancelLabel: "Cancel", kind: "warning" });
  if (ok) logout();
  return ok;
}
